module.exports = __webpack_public_path__ + "static/mighty-10890430bc009ef4fe88c4b00549e0cb.svg";